<template>
  <v-off-canvas
    id="template-day-item-details-offcanvas"
    :backdrop-static="false"
    offcanvas-class="item-details offcanvas-end"
    @closed="$emit('closed')"
  >
    <resizable-container>
      <off-canvas-header>
        <div class="d-flex align-items-center">
          <v-icon class="text-primary" icon="info" size="xl" space="me-8" />

          <h5 id="template-day-item-details-offcanvas-label" class="offcanvas-title">
            {{ $t("tourBuilder.itemDetails") }}
          </h5>
        </div>
      </off-canvas-header>

      <off-canvas-body>
        <v-loader v-if="status === 'loading' || !userStore.currentTourDayItem" />

        <template v-else>
          <the-template-day-item-details-create-form-v2
            v-if="!!userStore.currentTourDayItem && userStore.currentTourDayItem.model === undefined"
            :agency="agency"
            :status="status"
            :template-id="templateId"
            @emit-reload-tour="$emit('emitReloadTour')"
          />

          <the-template-day-item-details-update-form-v2
            v-else
            :agency="agency"
            :status="status"
            :template-id="templateId"
            :is-collaborator="isCollaborator"
            @deleted-item-resource="deletedItemResource = true"
            @emit-reload-tour="$emit('emitReloadTour')"
          />
        </template>
      </off-canvas-body>
    </resizable-container>
  </v-off-canvas>
</template>

<script lang="ts" setup>
import VOffCanvas from "@/components/vendor/basic/offcanvas/VOffCanvas.vue";
import OffCanvasHeader from "@/components/vendor/basic/offcanvas/OffCanvasHeader.vue";
import OffCanvasBody from "@/components/vendor/basic/offcanvas/OffCanvasBody.vue";
import VIcon from "@/components/vendor/basic/icon/VIcon.vue";
import VLoader from "@/components/vendor/loader/VLoader.vue";
import { useUserStore } from "@/stores/user";
import useConcepts from "@/helpers/Concepts";
import TheTemplateDayItemDetailsUpdateFormV2 from "@/components/template/V2/TheTemplateDayItemDetailsUpdateFormV2.vue";
import TheTemplateDayItemDetailsCreateFormV2 from "@/components/template/V2/TheTemplateDayItemDetailsCreateFormV2.vue";
import ResizableContainer from "@/components/resizablecontainer/ResizableContainer.vue";
import { onUnmounted, ref, watch } from "vue";

const { agency, templateId, status, isCollaborator } = defineProps({
  agency: { type: String, required: true },
  templateId: { type: Number, required: true },
  status: { type: String, required: true },
  isCollaborator: { type: Boolean, default: false },
});

const emit = defineEmits(["closed", "emitReloadTour"]);

const userStore = useUserStore();
const deletedItemResource = ref(false);

watch(
  userStore.currentTourDayItem,
  (value) => {
    if (deletedItemResource.value && value && value.resources && value.resources.length === 0) {
      emit("emitReloadTour");
    }
  },
  { deep: true }
);

onUnmounted(() => {
  userStore.setCurrentTemplateDayItem(null);
});
</script>

<style lang="scss" scoped>
.accordion-item {
  background-color: transparent;
}

.accordion .accordion-item .accordion-button {
  font-size: 1rem;
}

.accordion-button,
.accordion-button:not(.collapsed) {
  background-color: transparent;
}
</style>
